import React, { useState, useRef, Fragment, useEffect } from "react";
import {
  POST_PROCESSPAYMENT_URL,
  POST_ENDUSER_CREATE_URL,
  GET_AGENCY_CONVENIENCE_FEE_URL,
  CREATE_CUSTOMER_URL,
} from "../../../utils/APIEndpoints";
import { useSelector, useDispatch } from "react-redux";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import {
  getAlertToast,
  b64toBlob,
  detectCardType,
  getAlert,
  Uint8ToBase64,
  fixedTwoDigitsFloatValue,
  fillParagraph,
  getCurrentUserId,
  getCurrentAgencyId,
} from "../../../utils/functions/CustomFunctions";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Alert, InputGroupText,
  InputGroup,
  CardText,
  Table,
} from "reactstrap";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Col,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomLoader from "../../common/CustomLoader";
import {
  GOTO_SELECTED_STEP,
  RESET_APPLICATION_FORM,
  SET_CONVENIENCE_FEE,
} from "../../../redux/actions/ActionTypes";
import {
  NUMBER_SPACE_HYPHEN_ALLOWED,
  NUMBER_REGEX,
} from "../../../utils/constants/ValidationRegexs";
import cardTypes from "../../../utils/constants/ccImgTypes";
import { debounce } from "underscore";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import {
  DEV_CAPTCHA_SITE_KEY,
} from "../../../utils/GoogleCaptchaKeys";

//Config
const checkboxImagesSize = {
  Small: 10,
  Medium: 20,
  Large: 30,
};

export default function Payment(props) {
  //hooks
  const { documentDetails = {}, customCurrentStep } = props;
  const recaptchaRef = useRef();
  const applicationFormState = useSelector((state) => state.ApplicationForm);
  const [paymentFlag, setPaymentFlag] = useState(false);
  const HandleDocumentFormat = useSelector(
    (state) => state.HandleDocumentFormat
  );
  const recaptchaId = `recaptcha-${Math.random().toString(36).substring(7)}`;
  const dispatch = useDispatch();
  const { step1 = {}, base64WebForm = "" } = applicationFormState;
  const { documentsType = "" } = HandleDocumentFormat;
  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    address,
    city,
    state,
    postalcode,
    agencyServiceId,
    additionalDocuments,
    paymentAmount = 0,
    convenienceFee = 0,
    locationCodeId = "",
  } = step1;

  const { applicationValues = [] } = applicationFormState.step2;
  const variableValue = useSelector((state) => state.VariantsListReducer);
  const { data = [] } = variableValue;
  const from = useSelector((state) => state.FormReducer);
  const { formValues = [] } = from;
  const [flag, setFlag] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [isCaptchaLoading, setIsCaptchaLoading] = useState(false);
  const {
    serviceDescription = "",
    serviceName = "",
    serviceAmount = 0,
  } = documentDetails;

  // For Payment Variable Calculation
  let variablesArray = [],
    variablesTotal = 0;
  if (documentsType !== "WebForm") {
    applicationValues.forEach((document) =>
      document && document.elements
        .filter((element) => element.propertyType === "Variable")
        .forEach(
          ({
            variableCount,
            variableId,
            variableLabel,
            variableFee,
            checkboxValue,
            variableTypeId,
            hidePlaceholder,
            isNonDisplayVariable,
            selectedValue,
          }) => {
            if (variableTypeId == "1") {
              if (checkboxValue) {
                variablesTotal = variablesTotal + parseFloat(variableFee);
              }
            } else if (variableTypeId == "2") {
              variablesTotal =
                variablesTotal +
                parseFloat(variableCount) * parseFloat(variableFee);
            } else if (variableTypeId == "3") {
              if (isNonDisplayVariable === "false") {
                variablesTotal = variablesTotal + parseFloat(variableFee);
              }
              // variablesTotal = variablesTotal + parseFloat(variableFee);
            } else {
              variablesTotal = variablesTotal + parseFloat(variableFee);
            }

            let index = variablesArray.findIndex(
              (fee) => fee.feesId == variableId
            );
            if (index != -1) {
              let count =
                parseFloat(variablesArray[index].count) +
                parseFloat(variableCount);

              variablesArray[index] = {
                ...variablesArray[index],
                count: variableTypeId == "3" || variableId == "3" ? 1 : count,
              };
            } else {
              let newcount = 1;
              if (!checkboxValue && variableTypeId == "1") {
                newcount = 0;
              }

              variablesArray.push({
                feesId: variableId,
                count: ["1", "3"].includes(variableTypeId)
                  ? newcount
                  : variableCount,
                label: variableLabel,
                fees: variableFee,
                typeId: variableTypeId,
                hide: hidePlaceholder,
                isNonDisplayVariable: isNonDisplayVariable,
              });
            }
          }
        )
    );
  } else {
    applicationValues.map(({ elements = [] }) =>
      elements.map((val) => {
        const { label, type, selectedValue, variableId, feesId } = val;
        if (type === "variable") {
          data != null && data.forEach((value) => {
            const {
              feesId,
              labelName,
              price,
              agencyServiceId,
              isNonDisplayVariable,
              fees,
            } = value;
            if (val.feesId == feesId) {
              variablesTotal =
                variableId == 3 && isNonDisplayVariable === false
                  ? variablesTotal + parseFloat(selectedValue)
                  : variableId == 4 || variableId == 5
                  ? variablesTotal + parseFloat(selectedValue)
                  : variablesTotal + price * parseFloat(selectedValue);
              let index = variablesArray.findIndex(
                (fee) => fee.feesId == feesId
              );
              if (index != -1) {
                let count =
                  parseFloat(variablesArray[index].count) +
                  parseFloat(selectedValue);
                variablesArray[index] = {
                  ...variablesArray[index],
                  count: count,
                };
              } else {
                variablesArray.push({
                  feesId: feesId,
                  count:
                    variableId == "5" || variableId == "3" ? 1 : selectedValue,
                  // count: count,
                  label: labelName,
                  fees:
                    variableId == "3"
                      ? selectedValue
                      : variableId != "5"
                      ? price
                      : selectedValue,
                  typeId: variableId,
                  isNonDisplayVariable: isNonDisplayVariable,
                });
              }
            }
          });
        }
      })
    );
  }
  console.warn(variablesArray, "variablesArray");
  // //Functionality of single product check in webform
  // let index = storeValue.findIndex(
  //   (fee) => fee.feesId == values.feesId
  // );
  // if ((index = -1)) {
  //   let count =
  //     parseFloat(storeValue[index].count) +
  //     parseFloat(data.selectedValue);
  //   let fees =
  //     parseFloat(storeValue[index].fees) + parseFloat(values.price);
  //   storeValue[index] = {
  //     ...storeValue[index],
  //     count: count,
  //     fees: fees,
  //   };
  // } else {
  //   storeValue.push({
  //     feesId: data.feesId,
  //     count: parseFloat(data.selectedValue),
  //     label: data.labelName,
  //     fees: parseFloat(data.price),
  //     typeId: data.feeVariableTypeId,
  //   });
  // }
  let storeValue = [];
  (applicationValues[0]?.elements || [])
    .filter((element) => element.type === "variable" && element.variableId == 1)
    .map((element) => {
      if (element.selectedValue) {
        data != null &&
          data.forEach((values) => {
            if (String(values.feesId).includes(element.feesId.toString())) {
              let index = storeValue.findIndex(
                (fee) => fee.feesId == values.feesId
              );
              if (index != -1) {
                let count =
                  parseFloat(storeValue[index].count) +
                  parseFloat(element.selectedValue);
                let fees =
                  parseFloat(storeValue[index].fees) + parseFloat(values.price);
                storeValue[index] = {
                  ...storeValue[index],
                  count: count,
                  fees: fees,
                };
              } else {
                storeValue.push({
                  feesId: values.feesId,
                  count: parseFloat(element.selectedValue) || 0,
                  label: values.labelName,
                  fees: parseFloat(values.price),
                  typeId: values.feeVariableTypeId,
                });
              }
            }
          });
      }
    });

  //Functionality of single Product check in pdf
  let storePdfValue = [];
  applicationValues.map((document) =>
    document && document.elements
      .filter(
        (element) =>
          element.propertyType === "Variable" && element.variableTypeId == 1
      )
      .map((data) => {
        if (data.variableTypeId == 1 && data.checkboxValue == true) {
          let index = storePdfValue.findIndex(
            (fee) => fee.feesId == data.variableId
          );
          if (index != -1) {
            let count = parseFloat(storePdfValue[index].count) + 1;
            let fees =
              parseFloat(storePdfValue[index].fees) +
              parseFloat(data.variableFee);
            storePdfValue[index] = {
              ...storePdfValue[index],
              count: count,
              fees: fees,
            };
          } else {
            storePdfValue.push({
              feesId: data.variableId,
              count: parseFloat(data.variableCount) + 1,
              label: data.variableLabel,
              fees: parseFloat(data.variableFee),
              typeId: data.variableTypeId,
            });
          }
        }
      })
  );

  // Calculating SingleProduct
  let singleProductTotalValue = 0;
  if (documentsType === "Pdf") {
    singleProductTotalValue = 0;
    storePdfValue.map((data) => {
      const { fees } = data;
      singleProductTotalValue += fees;
    });
  } else {
    singleProductTotalValue = 0;
    storeValue.map((data) => {
      const { fees } = data;
      singleProductTotalValue += fees;
    });
  }
  //Total Amount To Pay
  const totalAmountToPay =
    parseFloat(paymentAmount) +
    parseFloat(convenienceFee) +
    parseFloat(variablesTotal);
  // parseFloat(singleProductTotalValue);

  //state
  const [documentUrl, setDocumentUrl] = useState("");
  const initialForm = {
    cardNumber: "",
    expirationMonth: "",
    expirationYear: "",
    cvv2: "",
  };

  const [loading, setLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [userCardType, setCardType] = useState("");
  const [isPasswordType, setPasswordInputType] = useState(true);
  const [isDocGenerateLoading, setIsDocGenerateLoading] = useState(false);

  const togglePasswordType = () => {
    setPasswordInputType(!isPasswordType);
  };

  //Payment api call
  const processPayment = async (body, documentUrl) => {
    try {
      setPaymentLoading(true);
      const options = {
        method: "POST",
        url: POST_PROCESSPAYMENT_URL,
        headers: authHeader(),
        data: body,
        // data: { body, uniqueUrl: documentUrl },
      };
      Swal.fire(getAlertToast("success", "Please wait..."));

      var apiResponse = await API(options);
      const { status, message } = apiResponse.data;
      if (status === "Error") {
        Swal.fire(getAlert("error", message));
      } else {
        let values = {
          customerName: body.firstName + " " + body.lastName,
          email: body.email,
          phoneNumber: body.phone,
          address: body.address1,
          city: body.city,
          state: body.state,
          zipCode: body.zip,
          description: "",
        };
        createCustomer(values);
        setPaymentFlag(true);
        Swal.fire(getAlert("success", "Payment Processed Successfully."));
        setDocumentUrl(documentUrl);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message || "Payment Failed"));
      }
    } finally {
      setPaymentLoading(false);
    }
  };

  // Overall Validations
  // Basic Details
  function checkBasicdetailsFilled() {
    //check it here
    let step1Values = { ...step1 };
    Object.keys(step1Values)
      .filter((key) =>
        ["paymentAmount", "agencyServiceId", "additionalDocuments"].includes(
          key
        )
      )
      .forEach((key) => delete step1Values[key]);

    for (var propName in step1Values) {
      if (step1Values[propName] === "") {
        Swal.fire(getAlertToast("error", "Please enter basic details"));
        return { isFilled: false, moveTo: 1 };
      }
    }
    return { isFilled: true, moveTo: 1 };
  }

  // Document Upload
  function checkDocumentsUploaded() {
    if (additionalDocuments && additionalDocuments.length) {
      let unFilledDocs = additionalDocuments.find(
        (document) => document.isRequired && !document.documentURL
      );
      if (unFilledDocs) {
        Swal.fire(getAlertToast("error", "Please upload required documents"));
        return { isFilled: false, moveTo: 1 };
      } else {
        return { isFilled: true, moveTo: 1 };
      }
    } else {
      return { isFilled: true, moveTo: 1 };
    }
  }
  function areFirstNCharactersHyphens(value, characterLimit) {
    // if (typeof value !== 'string') {
    //   return false; // Input is not a string
    // }
    const limit = parseInt(characterLimit || 0);

    if (value.length < limit) {
      return false; // The string is shorter than the specified character limit
    }

    // Use the substring method to extract the first 'characterLimit' characters
    const firstNCharacters = value.substring(0, limit);

    // Use a regular expression to check if all characters are hyphens
    const isAllHyphens = /-/.test(firstNCharacters);

    return isAllHyphens;
  }

  // Certficated Filled
  function checkCertificateFilled() {
    let isFilled = false;
    // if (paymentsType == "Variable" && variablesTotal == 0) {
    //   Swal.fire(
    //     getAlertToast("error", "Please give atleast one variable count")
    //   );
    //   return { isFilled, moveTo: 3 };
    // }
    if (documentsType === "Pdf") {
      applicationValues.some(({ elements }) => {
        let unFilledElements = elements.map(
          (element) =>
            (element.propertyType === "Text" &&
              !element.textValue &&
              element.isRequired) ||
            (element.propertyType === "Variable" &&
              !element.variableCount &&
              element.isRequired) ||
            (element.propertyType === "Image" &&
              !element.imageValue &&
              element.isRequired) ||
            (element.propertyType === "Number" &&
              !element.textValue &&
              element.isRequired) ||
            (element.propertyType === "Date" &&
              !element.textValue &&
              element.isRequired) ||
            (element.propertyType === "Signature" &&
              !element.imageValue &&
              element.isRequired) ||
            (element.propertyType === "MaskedTextBox" &&
              element.isRequired &&
              areFirstNCharactersHyphens(
                element.maskedvalue,
                element.characterLimit
              ))
        );
        let isUnfilledExist = unFilledElements.some((record) => record); //if array contains true [true,false]
        if (isUnfilledExist) {
          Swal.fire(getAlertToast("error", "Please enter certificate values"));
          isFilled = false;
          return true;
        } else {
          isFilled = true;
        }
      });
      return { isFilled, moveTo: 3 };
    } else {
      applicationValues.some(({ elements }) => {
        let unFilledElements = elements.map(
          (element) =>
            (element.type === "variable" &&
              (element.selectedValue === 0 ||
                element.selectedValue === "" ||
                element.selectedValue === "0") &&
              element.isMandatory === true) ||
            (element.type === "text" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "textarea" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "radio" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "checkbox" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "select" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "date" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "time" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "number" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "number" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.type === "maskedtextbox" &&
              element.selectedValue === "" &&
              element.isMandatory === true) ||
            (element.propertyType === "MaskedTextBox" &&
              element.isRequired &&
              areFirstNCharactersHyphens(
                element.maskedvalue,
                element.characterLimit
              ))
        );
        let isUnfilledExist = unFilledElements.some((record) => record);
        //if array contains true [true,false]
        if (isUnfilledExist) {
          Swal.fire(getAlertToast("error", "Please enter certificate values"));
          isFilled = false;
          return true;
        } else {
          isFilled = true;
        }
      });
      return { isFilled, moveTo: 3 };
    }
  }

  const validateFieldsAreFilled = () => {
    var arrayOfFunctions = [];
    let storePayment = false;
    arrayOfFunctions.push(checkBasicdetailsFilled);
    arrayOfFunctions.push(checkDocumentsUploaded);
    arrayOfFunctions.push(checkCertificateFilled);

    arrayOfFunctions.some(function (elem) {
      let { isFilled, moveTo } = elem();
      if (!isFilled) {
        dispatch({
          type: GOTO_SELECTED_STEP,
          payload: moveTo,
        });
        storePayment = false;
        return true;
      } else {
        storePayment = true;
      }
    });
    return { storePayment };
  };

  const getPreviewDocumentBase64Data = async () => {
    setIsDocGenerateLoading(true);
    try {
      let newData = await getPreviewDocumentBase64();
      setIsDocGenerateLoading(false);
      return newData;
    } catch (error) {
      console.error(error);
    return null;
    // react 17 upgrade fix
      // let newData = await getPreviewDocumentBase64();
      // setIsDocGenerateLoading(false);
      // return newData;
    } finally {
      setIsDocGenerateLoading(false);
    }
  };

  // Return base64 of Preview Document with Data
  const getPreviewDocumentBase64 = async () => {
    const newDoc = await PDFDocument.create();
    const requests = await applicationValues.map(async (item, pgIndex) => {
      // const existingPdfBytes = await fetch(item.documentURL).then((res) =>
      //   res.arrayBuffer()
      // );

      // react 17 upgrade issue fix
      let existingPdfBytes;

try {
  const response = await fetch(item.documentURL);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  existingPdfBytes = await response.arrayBuffer();
} catch (err) {
  console.error("Failed to fetch PDF:", item.documentURL, err);
  throw err; // preserve existing behavior
}
      const pdfDoc = await PDFDocument.load(existingPdfBytes, {
        ignoreEncryption: true,
      });
      // font embed
      const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
      const timesRomanItalicFont = await pdfDoc.embedFont(
        StandardFonts.TimesRomanItalic
      );
      const timesRomanBoldFont = await pdfDoc.embedFont(
        StandardFonts.TimesRomanBold
      );
      const timesRomanBoldItalicFont = await pdfDoc.embedFont(
        StandardFonts.TimesRomanBoldItalic
      );
      // debugger;
      const pages = pdfDoc.getPages();
      const { width, height } = pages[0].getSize();
      const rotation = pages[0].getRotation().angle;
      const normalPdf = pages[0].ref.objectNumber != 23;
      //map elements to its positions.
  

      const ElementsPromise = await item.elements.map(async (element) => {
        //started
        let drawX,
          drawY = 0;
        let rotationRads = (rotation * Math.PI) / 180;
        let coordsFromBottomLeft = {
          x: element.xCord,
        };

        if (rotation === 90 || rotation === 270) {
          coordsFromBottomLeft.y =
            width - (element.yCord + parseInt(element.fontSize)) / 1;
        } else {
          coordsFromBottomLeft.y =
            height - (element.yCord + parseInt(element.fontSize)) / 1;
        }

        if (rotation === 90) {
          drawX =
            coordsFromBottomLeft.x * Math.cos(rotationRads) -
            coordsFromBottomLeft.y * Math.sin(rotationRads) +
            width;
          drawY =
            coordsFromBottomLeft.x * Math.sin(rotationRads) +
            coordsFromBottomLeft.y * Math.cos(rotationRads);
        } else if (rotation === 180) {
          drawX =
            coordsFromBottomLeft.x * Math.cos(rotationRads) -
            coordsFromBottomLeft.y * Math.sin(rotationRads) +
            width;
          drawY =
            coordsFromBottomLeft.x * Math.sin(rotationRads) +
            coordsFromBottomLeft.y * Math.cos(rotationRads) +
            width;
        } else if (rotation === 270) {
          drawX =
            coordsFromBottomLeft.x * Math.cos(rotationRads) -
            coordsFromBottomLeft.y * Math.sin(rotationRads);
          drawY =
            coordsFromBottomLeft.x * Math.sin(rotationRads) +
            coordsFromBottomLeft.y * Math.cos(rotationRads) +
            height;
        } else {
          //no rotation
          drawX = coordsFromBottomLeft.x;
          drawY = coordsFromBottomLeft.y;
        }
        // map text elements
        if (
          (element.propertyType === "Text" && element.textValue) ||
          (element.propertyType === "Number" && element.textValue) ||
          (element.propertyType === "Date" && element.textValue) ||
          (element.propertyType === "MaskedTextBox" && element.textValue)
        ) {
          const textWidth = timesRomanFont.widthOfTextAtSize(
            element.textValue,
            parseInt(element.fontSize)
          );

          let sourceText = element.textValue;
          if (
            element.propertyType === "Text" ||
            element.propertyType === "MaskedTextBox"
          ) {
            const mValue =
              element.characterLimit &&
              element.textValue?.toString()?.length > element.characterLimit
                ? element.textValue
                    ?.toString()
                    ?.substring(0, element.characterLimit)
                : element.textValue;
            sourceText = fillParagraph(
              element.propertyType === "MaskedTextBox"
                ? mValue
                : element.textValue,
              timesRomanFont,
              parseInt(element.fontSize),
              element.width
            );
          }
          const adjustment = {
            Left: element.xCord + 13,
            Right: element.xCord + element.width - textWidth - 13,
            Center: element.xCord + (element.width - textWidth) / 2 - 7,
          };

          // const adjustment = {
          //   Left: element.xCord + 10,
          //   Right: element.xCord + 10,
          //   Center: element.xCord + 10,
          // };
          //If Number Type
          let num_x_adjust = 0,
            num_y_adjust = 0;
          if (element.propertyType === "Number") {
            num_x_adjust = 3;
            num_y_adjust = 2;
          }
          pages[0].drawText(sourceText, {
            rotate: degrees(rotation),
            x:
              rotation == 0
                ? normalPdf
                  ? adjustment[element.justify] - 10
                  : drawX + 5 - num_x_adjust
                : drawX - 38,
            // y: height - element.yCord - 5 - element.fontSize, Center Right
            y:
              rotation == 0
                ? normalPdf
                  ? height - element.yCord - 10
                  : drawY + parseInt(element.fontSize) - 12 - num_y_adjust + 12
                : drawY,
            size: parseInt(element.fontSize) + 1,
            font:
              element.isBold && element.isItalic
                ? timesRomanBoldItalicFont
                : element.isBold
                ? timesRomanBoldFont
                : element.isItalic
                ? timesRomanItalicFont
                : timesRomanFont,
            color: rgb(0, 0, 0),
          });
        } else if (
          element.propertyType === "Variable" &&
          element.variableCount &&
          element.variableTypeId != 1
        ) {

          let Xinitial = 12;
          let Yinitial = 6;
          let ValueInitial = element.variableCount;
          if (element.variableTypeId == 3 || element.variableTypeId == 4) {
            Xinitial = 6;
            Yinitial = 0;
            ValueInitial = element.variableFee;
          }

          pages[0].drawText(fixedTwoDigitsFloatValue(ValueInitial), {
            rotate: degrees(rotation),
            x: rotation == 0 ? (normalPdf ? drawX - Xinitial : drawX) : drawX,
            y:
              rotation == 0
                ? normalPdf
                  ? height - element.yCord - element.fontSize + Yinitial
                  : height - element.yCord - element.fontSize
                : drawY,
            size: parseInt(element.fontSize),
            font:
              element.isBold && element.isItalic
                ? timesRomanBoldItalicFont
                : element.isBold
                ? timesRomanBoldFont
                : element.isItalic
                ? timesRomanItalicFont
                : timesRomanFont,
            color: rgb(0, 0, 0),
          });
        } else if (
          element.propertyType === "Variable" &&
          element.variableTypeId == 1
        ) {
          // Single Product Check box Value
          if (element.checkboxBase64) {
            let image = await pdfDoc.embedPng(element.checkboxBase64);

            pages[0].drawImage(image, {
              rotate: degrees(rotation),
              x:
                rotation == 0
                  ? normalPdf
                    ? element.xCord - 11
                    : drawX + 2
                  : drawX -
                    (checkboxImagesSize[element.checkboxSize]
                      ? checkboxImagesSize[element.checkboxSize]
                      : typeof element.checkboxSize == "number"
                      ? element.checkboxSize
                      : 10) +
                    5,
              y:
                rotation == 0
                  ? normalPdf
                    ? height -
                      element.yCord -
                      (checkboxImagesSize[element.checkboxSize]
                        ? checkboxImagesSize[element.checkboxSize]
                        : typeof element.checkboxSize == "number"
                        ? element.checkboxSize
                        : 10) +
                      2
                    : drawY -
                      parseInt(
                        checkboxImagesSize[element.checkboxSize]
                          ? checkboxImagesSize[element.checkboxSize]
                          : typeof element.checkboxSize == "number"
                          ? element.checkboxSize
                          : 10
                      ) +
                      2
                  : drawY,
              width: checkboxImagesSize[element.checkboxSize]
                ? checkboxImagesSize[element.checkboxSize]
                : typeof element.checkboxSize == "number"
                ? element.checkboxSize
                : 10,
              height: checkboxImagesSize[element.checkboxSize]
                ? checkboxImagesSize[element.checkboxSize]
                : typeof element.checkboxSize == "number"
                ? element.checkboxSize
                : 10,
            });
          }

          let imagewidth, imageHeight;
          if (element.checkboxSize == "Medium") {
            imagewidth = 30;
            imageHeight = 30;
          } else if (element.checkboxSize == "Large") {
            imagewidth = 40;
            imageHeight = 40;
          } else {
            imagewidth = 20;
            imageHeight = 20;
          }
          if (element.hidePlaceholder == false) {
            pages[0].drawText(
              `$${parseFloat(element.variableFee).toFixed(2)} - ${
                element.variableLabel
              }`,
              {
                rotate: degrees(rotation),
                x:
                  rotation == 0
                    ? normalPdf
                      ? element.xCord + imagewidth - 12
                      : drawX + imagewidth - 3
                    : drawX - 2,
                // y: height - element.yCord - 5 - element.fontSize,
                y:
                  rotation == 0
                    ? normalPdf
                      ? height - element.yCord - 6
                      : drawY + parseInt(element.fontSize) - imageHeight / 2 - 5
                    : drawY - 20,
                size: parseInt(element.fontSize),
                font:
                  element.isBold && element.isItalic
                    ? timesRomanBoldItalicFont
                    : element.isBold
                    ? timesRomanBoldFont
                    : element.isItalic
                    ? timesRomanItalicFont
                    : timesRomanFont,
                color: rgb(0, 0, 0),
              }
            );
          }
        } else if (
          (element.propertyType === "Image" ||
            element.propertyType === "Signature") &&
          element.imageValue
        ) {
          const responseBs64 = element.imageValue;
          if (
            responseBs64 &&
            typeof responseBs64 === "string" &&
            responseBs64.includes(",") &&
            responseBs64.split(",")[1]
          ) {
            let image = null;
            const imageData = responseBs64.split(",")[1];
            let imageType =
              imageData.charAt(0) === "/"
                ? "jpg"
                : imageData.charAt(0) === "i"
                ? "png"
                : "other";
            if (imageType === "jpg") {
              image = await pdfDoc.embedJpg(responseBs64);
            } else if (imageType === "png") {
              image = await pdfDoc.embedPng(responseBs64);
            }

            imageType !== "other" &&
              pages[0].drawImage(image, {
                rotate: degrees(rotation),
                x:
                  rotation == 0
                    ? element.propertyType === "Signature"
                      ? //
                        drawX - 12
                      : normalPdf
                      ? drawX
                      : drawX
                    : element.propertyType === "Signature"
                    ? drawX -
                      parseInt(element.height) +
                      parseInt(element.fontSize)
                    : drawX - parseInt(element.height),
                y:
                  rotation == 0
                    ? element.propertyType === "Signature"
                      ? //(finsihed)
                        drawY -
                        parseInt(element.height) +
                        parseInt(element.fontSize)
                      : normalPdf
                      ? //(finished)
                        height - element.yCord - parseInt(element.height)
                      : drawY - parseInt(element.height - 12)
                    : element.propertyType === "Signature"
                    ? //(doing)
                      drawY + 3
                    : drawY + 3,
                width: parseInt(element.width),
                height: parseInt(element.height),
              });
          }
        } else {
          if (element.checkboxBase64) {
            let image = await pdfDoc.embedPng(element.checkboxBase64);
            const type_adjust = element.checkboxType === "Dot" ? 14 : 4;
            // 5px padding provided
            pages[0].drawImage(image, {
              rotate: degrees(rotation),
              x:
                rotation == 0
                  ? normalPdf
                    ? element.xCord + type_adjust
                    : drawX + 3
                  : drawX -
                    (checkboxImagesSize[element.checkboxSize]
                      ? checkboxImagesSize[element.checkboxSize]
                      : typeof element.checkboxSize == "number"
                      ? element.checkboxSize
                      : 10) -
                    5,
              y:
                rotation == 0
                  ? normalPdf
                    ? height -
                      element.yCord -
                      (checkboxImagesSize[element.checkboxSize]
                        ? checkboxImagesSize[element.checkboxSize]
                        : typeof element.checkboxSize == "number"
                        ? element.checkboxSize
                        : 10) -
                      6
                    : drawY - parseInt(element.height) + 13
                  : drawY - 5,
              width: checkboxImagesSize[element.checkboxSize]
                ? checkboxImagesSize[element.checkboxSize]
                : typeof element.checkboxSize == "number"
                ? element.checkboxSize
                : 10,
              height: checkboxImagesSize[element.checkboxSize]
                ? checkboxImagesSize[element.checkboxSize]
                : typeof element.checkboxSize == "number"
                ? element.checkboxSize
                : 10,
            });
          }
        }
      });
      // debugger;
      await Promise.all(ElementsPromise);
      const [Page] = await newDoc.copyPages(pdfDoc, [0]);
      newDoc.insertPage(pgIndex, Page);
    });

    const returnData = await Promise.all(requests).then(async () => {
      const pdfBytes = await newDoc.save();
      var base64String = Uint8ToBase64(pdfBytes);
      return base64String;
    });
    return returnData;
  };

  const getPreviewWebForm = async () => {
    return base64WebForm;
  };

  //create user and call payment
  const onPaymentClick = async (form) => {
    const { storePayment } = validateFieldsAreFilled();
    if (storePayment) {
      const { cardNumber, expirationMonth, expirationYear, cvv2 } = form;
      let paymentBody = {
        firstName,
        lastName,
        address1: address,
        city,
        state,
        zip: postalcode,
        phone: phoneNumber,
        email,
        cardNumber: cardNumber.replace(/[^0-9]/g, ""),
        expirationMonth:
          expirationMonth.length < 2
            ? `0${expirationMonth}`
            : expirationMonth.toString(),
        expirationYear:
          expirationYear.length < 2
            ? `0${expirationYear}`
            : expirationYear.toString(),
        cvv2,
        endUserId: 0,
        paymentType: "Card",
        feesId: variablesArray.filter(
          (item) => item.isNonDisplayVariable !== "true"
        ),
        formURL: window.location.href,
      };

      //convert base64 to blob
      const documentBase64Data =
        documentsType === "WebForm"
          ? await getPreviewWebForm()
          : await getPreviewDocumentBase64Data();

      
      //react 17 upgrade fix
      if (!documentBase64Data) {
     console.log("Document base64 data is null or undefined. Aborting payment process.");
  return;
}

      let blob = await b64toBlob(documentBase64Data, "application/pdf");

      const formData = new FormData();

      formData.append("file", blob, "Certificate.pdf");
      formData.set("firstName", firstName);
      formData.set("lastName", lastName);
      formData.set("email", email);
      formData.set("phoneNumber", phoneNumber);
      formData.set("address", address);
      formData.set("agencyServiceId", agencyServiceId);
      formData.set("additionalDocuments", JSON.stringify(additionalDocuments));
      formData.set("city", city);
      formData.set("state", state);
      formData.set("postalcode", postalcode);
      formData.set("formURL", window.location.href);
      formData.set(
        "userPlaceHolderValue",
        JSON.stringify(applicationValues[0]?.elements || [])
      );


      try {
        console.error("try called");
        setLoading(true);
        const options = {
          method: "POST",
          url: POST_ENDUSER_CREATE_URL,
          headers: authHeader(),
          data: formData,
        };
        let response = await API(options);
        const { status, message, endUserId, invoiceId, documentUrl } =
          response.data;
        if (status === "Error") {
          Swal.fire(getAlertToast("error", message));
        } else {
          paymentBody.endUserId = endUserId;
          paymentBody.hyperlink = window.location.origin + "/requests"; //Route Link For Login From Email
          processPayment(paymentBody, documentUrl);
        }
      } catch (error) {
        if (error.response) {
          Swal.fire(
            getAlertToast("error", "Something went wrong please try again!")
          );
        }
      } finally {
        setLoading(false);
      }
    }
  };

  //on Zero Payment Click
  const onZeroPaymentClick = async () => {
    const { storePayment } = validateFieldsAreFilled();
    if (storePayment) {
      let paymentBody = {
        firstName,
        lastName,
        address1: address,
        city,
        state,
        zip: postalcode,
        phone: phoneNumber,
        email,
        endUserId: 0,
        feesId: variablesArray.map((item) => ({ ...item, fees: 0 })),
        formURL: window.location.href,
      };

      //convert base64 to blob
      const documentBase64Data =
        documentsType === "WebForm"
          ? await getPreviewWebForm()
          : await getPreviewDocumentBase64Data();

      let blob = await b64toBlob(documentBase64Data, "application/pdf");

      const formData = new FormData();
      formData.append("file", blob, "Certificate.pdf");
      formData.set("firstName", firstName);
      formData.set("lastName", lastName);
      formData.set("email", email);
      formData.set("phoneNumber", phoneNumber);
      formData.set("address", address);
      formData.set("agencyServiceId", agencyServiceId);
      formData.set("additionalDocuments", JSON.stringify(additionalDocuments));
      formData.set("city", city);
      formData.set("state", state);
      formData.set("postalcode", postalcode);

      try {
        setLoading(true);
        const options = {
          method: "POST",
          url: POST_ENDUSER_CREATE_URL,
          headers: authHeader(),
          data: formData,
        };
        let response = await API(options);
        const { status, message, endUserId, invoiceId } = response.data;
        if (status === "Error") {
          Swal.fire(getAlertToast("error", message));
        } else {
          paymentBody.endUserId = endUserId;
          processPayment(paymentBody);
        }
      } catch (error) {
        if (error.response) {
          Swal.fire(
            getAlertToast("error", "Something went wrong please try again!")
          );
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const createCustomer = async (values) => {
    values.createdBy = getCurrentUserId();
    values.agencyId = getCurrentAgencyId();
    try {
      const options = {
        method: "POST",
        url: CREATE_CUSTOMER_URL,
        headers: authHeader(),
        data: values,
      };
      const response = await API(options);
      const { status, message } = response.data;
      // if (status === 'Success') {
      //   Swal.fire(getAlertToast('success', message));
      // }
      // else if (status == 'Error') {
      //   Swal.fire(getAlertToast('error', message));
      // }
    } catch (error) {
      // if (error.response) {
      //   let { data } = error.response;
      //   Swal.fire(getAlertToast('error', data.message));
      // }
    } finally {
    }
  };

  //Reset All Form Fields
  const ResetAllFormFields = () => {
    dispatch({
      type: RESET_APPLICATION_FORM,
    });
  };

  const checkGivenCarType = (cardNumber) => {
    let { cardType, isCardValid } = detectCardType(cardNumber);
    if (!isCardValid) setFieldError("cardNumber", "Invalid Card Number");
    setCardType(cardType);
  };

  //Debounce
  const delayedQuery = useRef(
    debounce((cardNumber) => checkGivenCarType(cardNumber), 300)
  ).current;

  //Detect Entered Card Type
  const detectEnteredCardType = ({ target: { name, value } }) => {
    let trimmedValue = value.replace(/[^0-9]/g, "");
    if (trimmedValue) delayedQuery(trimmedValue);
    else setCardType("");
  };

  //Get Convenience Fee
  const getConvenienceFee = async () => {
    const certificate_and_variables_fee =
      parseFloat(paymentAmount) + parseFloat(variablesTotal);
    console.log(
      certificate_and_variables_fee,
      paymentAmount,
      variablesTotal,
      "payment"
    );
    try {
      const apiOptions = {
        method: "GET",
        url: GET_AGENCY_CONVENIENCE_FEE_URL,
        headers: authHeader(),
        params: {
          locationCodeId: parseInt(locationCodeId),
          amount: certificate_and_variables_fee,
        },
      };
      const feeResponse = await API(apiOptions);
      const { status: feeResRtatus } = feeResponse.data;
      if (feeResRtatus === "Success") {
        const { ServiceFeeAmount = 0 } = feeResponse.data;
        dispatch({
          type: SET_CONVENIENCE_FEE,
          payload: parseFloat(ServiceFeeAmount).toFixed(2),
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
      }
    }
  };

  useEffect(() => {
    getConvenienceFee();
  }, [variablesTotal]);

  //Formik
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    setFieldTouched,
    setErrors,
    setFieldError,
    setFieldValue,
  } = useFormik(
    {
      initialValues: initialForm,
      enableReinitialize: true,
      validationSchema: Yup.object().shape({
        cardNumber: Yup.string()
          .trim()
          .required("Credit card number is required")
          .min(16, "Enter valid card number")
          .matches(NUMBER_SPACE_HYPHEN_ALLOWED, "Enter valid card number"),
        expirationMonth: Yup.string()
          .trim()
          .required("Expiration month is required")
          .when("expirationYear", (expirationYear, schema) => {
            return schema.test({
              test: (expirationMonth) =>
                (expirationYear == currentYear &&
                  expirationMonth >= currentMonth) ||
                (expirationYear !== currentYear && expirationMonth),
              message: "Invalid month",
            });
          }),
        expirationYear: Yup.string()
          .trim()
          .required("Expiration Year is required"),
        cvv2: Yup.string()
          .trim()
          .required("CVV is required")
          .min(3, "CVV should be 3 or 4 digits")
          .max(4, "Four Digit is Maximum")
          .matches(NUMBER_REGEX, "Enter valid CVV number"),
      }),
      onSubmit: (values) => {

        onPaymentClick(values);
      },
    },
    ["expirationMonth"]
  );

  const {
    cardNumber = "",
    expirationMonth = "",
    expirationYear = "",
    cvv2 = "",
  } = values;

  var currentDate = new Date();
  var currentMonth = parseInt(currentDate.getMonth()) + 1;
  var currentYear = currentDate.getFullYear().toString().substr(-2);
  function generateNonce() {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }
   
   useEffect(() => {
     const renderCaptcha = () => {
       if (window.grecaptcha) {
         window.grecaptcha.ready(() => {
           if (recaptchaRef.current) {
             window.grecaptcha.render(recaptchaRef.current, {
               sitekey: DEV_CAPTCHA_SITE_KEY,
               callback: (token) => {
                 setIsCaptchaVerified(!!token);
               },
             });
           }
         });
       } else {
         console.error("grecaptcha not found on window");
       }
     };

     const loadRecaptchaScript = () => {
       const script = document.createElement("script");
       script.src = "https://www.google.com/recaptcha/api.js";
       script.async = true;
       script.defer = true;
       script.onload = () => {
         renderCaptcha();
       };
       script.onerror = (error) => {
         console.error("Error loading reCAPTCHA script:", error);
       };
       document.body.appendChild(script);
     };

     if (!window.grecaptcha) {
       loadRecaptchaScript();
     } else {
       renderCaptcha();
     }

     return () => {
       // Clean up reCAPTCHA and reset
       if (recaptchaRef.current) {
         recaptchaRef.current.innerHTML = ""; // Clear the container
       }
     };
   }, [DEV_CAPTCHA_SITE_KEY, paymentFlag]);

  //  prod prev
  // useEffect(() => {
  //   const nonce = generateNonce();
  //   const script = document.createElement("script");
  //   script.src = "https://www.google.com/recaptcha/api.js";
  //   script.async = true;
  //   script.defer = true;
  //   script.type = "text/javascript";
  //   script.id = new Date();
  //   script.nonce = nonce;
  //   script.onload = () => {
  //     window.grecaptcha.ready(() => {
  //       window.grecaptcha.render(recaptchaRef.current, {
  //         sitekey: DEV_CAPTCHA_SITE_KEY,
  //         callback: (token) => {
  //           if (token) {
  //             setIsCaptchaVerified(true);
  //             // handleCaptchaSubmit(token);
  //           } else {
  //             setIsCaptchaVerified(false);
  //           }
  //         },
  //       });
  //     });
  //   };

  //   script.onerror = (error) => {
  //     console.error("Error loading reCAPTCHA script:", error);
  //   };

  //   document.body.appendChild(script);

  //   return () => {
  //     // Cleanup script tag if component unmounts
  //     document.body.removeChild(script);
  //   };
  // }, []); 

  // useEffect(() => {
  //   // Ensure the reCAPTCHA Enterprise script has loaded
  //   if (
  //     window.grecaptcha &&
  //     typeof window.grecaptcha.enterprise.render === 'function'
  //   ) {
  //     window.grecaptcha.enterprise.render(recaptchaRef.current, {
  //       sitekey: DEV_CAPTCHA_SITE_KEY,
  //       // size: 'normal', // You can choose 'normal' if you want a visible widget
  //       callback: (token) => {
  //         // reCAPTCHA verification successful, you can do something here
  //         handleCaptchaSubmit(token);
  //       },
  //     });
  //   } else {
  //     console.error(
  //       'reCAPTCHA Enterprise library not found. Make sure you have included the reCAPTCHA Enterprise script.'
  //     );
  //   }
  // }, []);

  // const handleCaptchaSubmit = async (token) => {
  //   // const token = window.grecaptcha.getResponse();
  //   const secret = DEV_CAPTCHA_SECRET_KEY;
  //   setIsCaptchaLoading(true);
  //   const response = await fetch(
  //     "https://www.google.com/recaptcha/api/siteverify",
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //         // 'Access-Control-Allow-Origin': '*',
  //         // 'Content-Type': 'application/json',
  //       },
  //       // body: `secret=${secret}&response=${token}`,
  //       // params: {
  //       //   secret: secret,
  //       //   response: token,
  //       // },
  //     }
  //   );

  //   const data = await response.json();
  //   if (data.success) {
  //     // reCAPTCHA verification was successful; you can submit the form or take appropriate action here.
  //     // Example: You can submit the form data to your server here.
  //     setIsCaptchaVerified(true);
  //     setIsCaptchaLoading(false);
  //   } else {
  //     // reCAPTCHA verification failed; handle the error as needed.
  //     console.error("reCAPTCHA verification failed");
  //     setIsCaptchaLoading(false);
  //     setIsCaptchaVerified(false);
  //   }
  // };
  return (
    <>
      <React.Fragment>
        <Row>
          <Col md={6}>
            <Card>
              <CardBody>
                <center>
                  <CardTitle>CardHolder Information</CardTitle>

                  <div className="kt-widget__contentpay">
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay"> First Name :</span>
                      <span className="kt-widget__valuepay cardholder-info">
                        {firstName || "N/A"}
                      </span>
                    </div>
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay">Last Name : </span>
                      <span className="kt-widget__valuepay cardholder-info">
                        {lastName || "N/A"}
                      </span>
                    </div>
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay">Email :</span>
                      <span className="kt-widget__valuepay cardholder-info">
                        {email || "N/A"}
                      </span>
                    </div>
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay">
                        Phone Number :
                      </span >
                      <span className='cardholder-info'> (+1) {phoneNumber || "N/A"}</span>
                    </div>
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay">Address :</span>
                      <span className="kt-widget__valuepay cardholder-info">
                        {address || "N/A"}
                      </span>
                    </div>
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay">City :</span>
                      <span className="kt-widget__valuepay cardholder-info">
                        {city || "N/A"}
                      </span>
                    </div>
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay">State :</span>
                      <span className="kt-widget__valuepay cardholder-info">
                        {state || "N/A"}
                      </span>
                    </div>
                    <div className="kt-widget__infopay mb-2">
                      <span className="kt-widget__labelpay">Postal Code :</span>
                      <span className="kt-widget__valuepay cardholder-info">
                        {postalcode || "N/A"}
                      </span>
                    </div>
                  </div>
                </center>
              </CardBody>
            </Card>
          </Col>
          <Col md={6}>
            <Card>
              <CardBody>
                {!documentUrl ? (
                  <Fragment>
                    <Card body inverse style={{ backgroundColor: "#1b3e6f" }}>
                      <CardTitle style={{ color: "#fff", textAlign: "center" }}>
                        Fee Details
                      </CardTitle>
                      <CardText>
                        <Table responsive hover className="payment-table">
                          <thead>
                            <tr>
                              <th>Particulars</th>
                              <th>Count</th>
                              <th>Fee</th>
                            </tr>
                          </thead>
                          {/* Document Name */}
                          <tbody>
                            {paymentAmount && paymentAmount > 0 && (
                              <tr>
                                <td>{serviceName}</td>
                                <td>-</td>
                                <td>${parseFloat(paymentAmount).toFixed(2)}</td>
                              </tr>
                            )}
                            {/* single product */}
                            {documentsType === "Pdf" &&
                              storePdfValue.map((data, i) => {
                                const {
                                  fees = 0,
                                  label = "",
                                  count = 0,
                                } = data;
                                return (
                                  <tr key={i}>
                                    <td>{`$${parseFloat(fees).toFixed(
                                      2
                                    )} - ${label}`}</td>
                                    <td>{parseFloat(count).toFixed(2)}</td>
                                    <td> ${parseFloat(fees).toFixed(2)}</td>
                                  </tr>
                                );
                              })}

                            {documentsType === "WebForm" &&
                              storeValue.map((data, i) => {
                                const {
                                  fees = 0,
                                  label = "",
                                  count = 0,
                                } = data;
                                return (
                                  <tr key={i}>
                                    <td>{`$${parseFloat(fees).toFixed(
                                      2
                                    )} - ${label}`}</td>
                                    <td>{parseFloat(count).toFixed(2)}</td>
                                    <td> ${parseFloat(fees).toFixed(2)}</td>
                                  </tr>
                                );
                              })}

                            {/* other types Variables */}
                            {variablesArray.map(
                              ({
                                label,
                                fees,
                                count,
                                typeId,
                                isNonDisplayVariable,
                              }) => {

                                if (typeId == 4) {
                                  // Type 4 calculation
                                  if (count > 0) {
                                    return (
                                      <tr key={label}>
                                        <td>{label}</td>
                                        <td>-</td>
                                        {documentsType === "WebForm" ? (
                                          <td>
                                            ${parseFloat(count).toFixed(2)}
                                          </td>
                                        ) : (
                                          <td>
                                            ${parseFloat(fees).toFixed(2)}
                                          </td>
                                        )}
                                      </tr>
                                    );
                                  }
                                } else if (typeId == 5) {
                                  // Type 4 calculation
                                  if (count > 0) {
                                    return (
                                      <tr key={label}>
                                        <td>{label}</td>
                                        <td>-</td>
                                        {documentsType === "WebForm" ? (
                                          <td>
                                            ${parseFloat(fees).toFixed(2)}
                                          </td>
                                        ) : (
                                          <td>
                                            ${parseFloat(fees).toFixed(2)}
                                          </td>
                                        )}
                                      </tr>
                                    );
                                  }
                                } else if (count > 0 && typeId == 2) {
                                  // Type 2 calculation
                                  return (
                                    <tr key={label}>
                                      <td>{`$${fees} - ${label}`}</td>
                                      <td>{parseFloat(count).toFixed(2)}</td>
                                      <td>
                                        $
                                        {parseFloat(
                                          count * parseFloat(fees).toFixed(2)
                                        ).toFixed(2)}
                                      </td>
                                    </tr>
                                  );
                                } else {
                                  //Type 3 calculation we need to hide the isNonDisplayVariable (UI ONLY)
                                  if (
                                    typeId == 3 &&
                                    fees > 0 &&
                                    (isNonDisplayVariable === "false" ||
                                      isNonDisplayVariable === false)
                                  ) {
                                    return (
                                      <tr key={label}>
                                        <td>{label}</td>
                                        <td>-</td>
                                        <td>${parseFloat(fees).toFixed(2)}</td>
                                      </tr>
                                    );
                                  }
                                }
                              }
                            )}
                            {/* other Fees */}
                            <tr>
                              <td>Convenience Fee</td>
                              <td>-</td>
                              <td>${parseFloat(convenienceFee).toFixed(2)}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td>Total Fee</td>
                              <td></td>
                              <td>
                                ${parseFloat(totalAmountToPay).toFixed(2)}
                              </td>
                            </tr>
                          </tfoot>
                        </Table>
                      </CardText>
                    </Card>{" "}
                    {totalAmountToPay !== 0 ? (
                      <>
                        <CardTitle style={{ marginTop: "1rem" }}>
                          <center>Payment</center>
                        </CardTitle>

                        <Form onSubmit={handleSubmit}>
                          <FormGroup row>
                            <Label for="exampleSelect" sm={4}>
                              Payment Type
                            </Label>
                            <Col sm={8}>
                              <Input
                                type="select"
                                name="select"
                                id="exampleSelect"
                                disabled
                              >
                                <option>Credit Card</option>
                              </Input>
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Label for="CreditCard" sm={4}>
                              Card Number
                            </Label>
                            <Col sm={6}>
                              <Input
                                type="text"
                                name="cardNumber"
                                id="CreditCard"
                                invalid={
                                  errors.cardNumber && touched.cardNumber
                                    ? true
                                    : false
                                }
                                onChange={(event) => {
                                  setFieldTouched("cardNumber", true);
                                  handleChange(event);
                                  detectEnteredCardType(event);
                                }}
                                onBlur={handleBlur}
                                value={cardNumber}
                                placeholder="Enter credit card number"
                              />
                              <FormFeedback>
                                {errors.cardNumber && touched.cardNumber
                                  ? errors.cardNumber
                                  : ""}
                              </FormFeedback>
                            </Col>
                            <Col md={2}>
                              {userCardType && (
                                <img
                                  style={{
                                    width: "60px",
                                    height: "40px",
                                    marginLeft: "-7px",
                                  }}
                                  src={cardTypes[userCardType]}
                                  alt="no data"
                                />
                              )}
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Label for="Expiration" sm={4}>
                              Expiration
                            </Label>
                            <Col sm={4}>
                              <Input
                                type="number"
                                min={1}
                                max={12}
                                step={1}
                                name="expirationMonth"
                                id="Expiration"
                                invalid={
                                  errors.expirationMonth &&
                                  touched.expirationMonth
                                    ? true
                                    : false
                                }
                                onBlur={handleBlur}
                                onChange={({ target: { value } }) => {
                                  setFieldTouched("expirationMonth", true);
                                  if (value.length <= 2) {
                                    setFieldValue("expirationMonth", value);
                                  } else {
                                    return;
                                  }
                                }}
                                value={expirationMonth}
                                placeholder="MM"
                              />
                              <FormFeedback>
                                {errors.expirationMonth &&
                                touched.expirationMonth
                                  ? errors.expirationMonth
                                  : ""}
                              </FormFeedback>
                            </Col>
                            <Col sm={4}>
                              <Input
                                type="number"
                                min={currentYear}
                                step={1}
                                name="expirationYear"
                                id="expirationYear"
                                invalid={
                                  errors.expirationYear &&
                                  touched.expirationYear
                                    ? true
                                    : false
                                }
                                onBlur={handleBlur}
                                onChange={({ target: { value } }) => {
                                  setFieldTouched("expirationYear", true);
                                  if (value.length <= 2) {
                                    setFieldValue("expirationYear", value);
                                  } else {
                                    return;
                                  }
                                }}
                                value={expirationYear}
                                placeholder="YY"
                              />
                              <FormFeedback>
                                {errors.expirationYear && touched.expirationYear
                                  ? errors.expirationYear
                                  : ""}
                              </FormFeedback>
                            </Col>{" "}
                          </FormGroup>
                          <FormGroup row>
                            <Label for="CVV" sm={4}>
                              CVV
                            </Label>
                            <Col sm={8}>
                              <InputGroup>
                                {" "}
                                <Input
                                  type={isPasswordType ? "password" : "text"}
                                  name="cvv2"
                                  id="CVV"
                                  invalid={
                                    errors.cvv2 && touched.cvv2 ? true : false
                                  }
                                  onBlur={handleBlur}
                                  onChange={(event) => {
                                    setFieldTouched("cvv2", true);
                                    handleChange(event);
                                  }}
                                  value={cvv2}
                                  maxLength={4}
                                  placeholder="CVV"
                                />
                                
                                  <InputGroupText
                                    onClick={togglePasswordType}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {isPasswordType ? (
                                      <i className="fas fa-eye-slash" />
                                    ) : (
                                      <i className="fas fa-eye" />
                                    )}
                                  </InputGroupText>
                                
                                <FormFeedback>
                                  {errors.cvv2 && touched.cvv2
                                    ? errors.cvv2
                                    : ""}
                                </FormFeedback>
                              </InputGroup>
                            </Col>
                          </FormGroup>
                          <Row>
                            <Col sm={4}>
                              {/* <CapFun recaptchaRef={recaptchaRef} /> */}
                            </Col>
                          </Row>
                          <Row>
                            {/* <Col sm={4}>
                            <Button onClick={getbase64Data}>base64</Button>
                          </Col> */}

                            <Col sm={8}>
                              {/* <Button
                                disabled={
                                  loading ||
                                  paymentLoading ||
                                  isDocGenerateLoading ||
                                  !isCaptchaVerified ||
                                  isCaptchaLoading
                                }
                                type="submit"
                                color="primary"
                              >
                                {(loading || isDocGenerateLoading) && (
                                  <CustomLoader
                                    loading={loading || isDocGenerateLoading}
                                  />
                                )}
                                Make Payment
                              </Button> */}
                            </Col>
                          </Row>
                        </Form>
                      </>
                    ) : (
                      <div style={{ margin: "15px" }}>
                        {" "}
                        <Row>
                          <Col sm={4}>
                            {/* <CapFun recaptchaRef={recaptchaRef} /> */}
                          </Col>
                        </Row>
                        {/* <Col sm={4}>
                        <Button onClick={getbase64Data}>base64</Button>
                      </Col> */}
                        {/* <Button
                          disabled={
                            loading ||
                            paymentLoading ||
                            isDocGenerateLoading ||
                            !isCaptchaVerified ||
                            isCaptchaLoading
                          }
                          onClick={onZeroPaymentClick}
                          color="primary"
                          size="lg"
                        >
                          {(loading || isDocGenerateLoading) && (
                            <CustomLoader
                              loading={loading || isDocGenerateLoading}
                            />
                          )}
                          Submit
                        </Button> */}
                      </div>
                    )}
                  </Fragment>
                ) : (
                  <></>
                  // SUCCESS
                  // <div>
                  //   <Alert color="success">
                  //     <h4 className="alert-heading">Payment Success!</h4>
                  //     <p>
                  //       You have successfully paid
                  //       <b> ${parseFloat(totalAmountToPay).toFixed(2)} </b> for
                  //       this certificate.
                  //     </p>
                  //     <hr />
                  //     <p className="mb-0">
                  //       <a
                  //         href={documentUrl}
                  //         target="_blank"
                  //         download="certificate.pdf"
                  //         style={{
                  //           color: "#fff",
                  //           border: "1px solid #eee",
                  //           backgroundColor: "firebrick",
                  //           padding: "8px",
                  //         }}
                  //       >
                  //         <i className="fas fa-file-download"></i>
                  //         {"  "} Certificate
                  //       </a>
                  //       <Button
                  //         style={{ marginLeft: "10px", marginTop: "-4px" }}
                  //         type="button"
                  //         color="primary"
                  //         onClick={ResetAllFormFields}
                  //       >
                  //         Apply More
                  //       </Button>
                  //     </p>
                  //   </Alert>
                  // </div>
                )}
                {!paymentFlag && (
                  <div
                    ref={recaptchaRef}
                    className="g-recaptcha"
                    data-sitekey={DEV_CAPTCHA_SITE_KEY}
                    data-action="Payment"
                    id={recaptchaId}
                  ></div>
                )}

                {totalAmountToPay !== 0 && !paymentFlag ? (
                  <Col sm={8}>
                    <Button
                      disabled={
                        loading ||
                        paymentLoading ||
                        isDocGenerateLoading ||
                        !isCaptchaVerified ||
                        isCaptchaLoading
                      }
                      type="submit"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {(loading || isDocGenerateLoading) && (
                        <CustomLoader
                          loading={loading || isDocGenerateLoading}
                        />
                      )}
                      Make Payment
                    </Button>
                  </Col>
                ) : (
                  !paymentFlag && (
                    <Button
                      disabled={
                        loading ||
                        paymentLoading ||
                        isDocGenerateLoading ||
                        !isCaptchaVerified ||
                        isCaptchaLoading
                      }
                      onClick={onZeroPaymentClick}
                      color="primary"
                      size="lg"
                    >
                      {(loading || isDocGenerateLoading) && (
                        <CustomLoader
                          loading={loading || isDocGenerateLoading}
                        />
                      )}
                      Submit
                    </Button>
                  )
                )}
                {paymentFlag && (
                  <div>
                    <Alert color="success">
                      <h4 className="alert-heading">Payment Success!</h4>
                      <p>
                        You have successfully paid
                        <b> ${parseFloat(totalAmountToPay).toFixed(2)} </b> for
                        this certificate.
                      </p>
                      <hr />
                      <p className="mb-0">
                        <a
                        className="link"
                          href={documentUrl}
                          target="_blank"
                          download="certificate.pdf"
                          style={{
                            color: "#fff",
                            border: "1px solid #eee",
                            backgroundColor: "firebrick",
                            padding: "8px",
                          }}
                        >
                          <i className="fas fa-file-download"></i>
                          {"  "} Certificate
                        </a>
                        <Button
                          style={{ marginLeft: "10px", marginTop: "-4px" }}
                          type="button"
                          color="primary"
                          onClick={ResetAllFormFields}
                        >
                          Apply More
                        </Button>
                      </p>
                    </Alert>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    </>
  );
}

